import { createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'
import { getCourseFilter, postCourseList } from 'src/services/course/list'
import { initialState } from './model'

const courseList = createSlice({
  name: 'courseList',
  initialState,
  reducers: {
    startLoadMore: (state) => {
      state.isLoadMore = true
    },
    stopLoadMore: (state) => {
      state.isLoadMore = false
    },
    setFilter: (state, { payload }) => {
      const { key, value } = payload
      state.filterBody[key] = value
      state.filterBody.page = 1
    },
    setLoadMore: (state) => {
      const nextPage = state.filterBody.page + 1
      const maxPage = _.ceil(state.totalCourses / 12)
      if (nextPage <= maxPage) state.filterBody.page = nextPage
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCourseFilter.fulfilled, (state, { payload }) => {
        state.filterData = _.get(payload, 'data', null)
      })
      .addCase(getCourseFilter.rejected, (state, action) => {
        state.error = action.meta?.message
      })
      .addCase(postCourseList.fulfilled, (state, action) => {
        const { meta, payload } = action
        const courses = _.get(payload, 'data.courses', [])
        const isFilter = _.get(meta.arg, 'page', 1) == 1
        if (isFilter) state.courses = courses
        else state.courses = _.concat(state.courses, courses)
        state.totalCourses = _.get(payload, 'data.totalCourses', [])
      })
      .addCase(postCourseList.rejected, (state, action) => {
        state.error = action.meta?.message
      })
  },
})

export const { startLoadMore, stopLoadMore, setFilter, setLoadMore } =
  courseList.actions

export default courseList.reducer
